Object.defineProperty(exports, "__esModule", { value: true });
exports.compileInputObjectType = exports.compileInputObjectTypeWithConfig = void 0;
const graphql_1 = require("graphql");
const InputObjectType_1 = require("./InputObjectType");
const InputFieldDecorators_1 = require("../inputField/InputFieldDecorators");
const cachedThunk_1 = require("../../services/utils/cachedThunk");
const inheritance_1 = require("../../services/utils/inheritance");
const compileOutputTypeCache = new WeakMap();
function createTypeInputFieldsGetter(target) {
    const targetWithParents = inheritance_1.getClassWithAllParentClasses(target);
    const hasFields = targetWithParents.some((ancestor) => {
        return !InputFieldDecorators_1.inputFieldsRegistry.isEmpty(ancestor);
    });
    if (!hasFields) {
        throw new InputObjectType_1.InputObjectTypeError(target, `There are no fields inside this type.`);
    }
    return cachedThunk_1.createCachedThunk(() => {
        return InputFieldDecorators_1.compileAllInputFields(target);
    });
}
function compileInputObjectTypeWithConfig(target, config) {
    if (compileOutputTypeCache.has(target)) {
        return compileOutputTypeCache.get(target);
    }
    const compiled = new graphql_1.GraphQLInputObjectType({
        ...config,
        fields: createTypeInputFieldsGetter(target)
    });
    compileOutputTypeCache.set(target, compiled);
    return compiled;
}
exports.compileInputObjectTypeWithConfig = compileInputObjectTypeWithConfig;
function compileInputObjectType(target) {
    if (!InputObjectType_1.inputObjectTypeRegistry.has(target)) {
        throw new InputObjectType_1.InputObjectTypeError(target, `Class is not registered. Make sure it's decorated with @InputObjectType decorator`);
    }
    const compiler = InputObjectType_1.inputObjectTypeRegistry.get(target);
    return compiler();
}
exports.compileInputObjectType = compileInputObjectType;
//# sourceMappingURL=objectTypeCompiler.js.map